export const Sections = {
  99: {
    name: "", // represents Landing Page
    0: {
      name: "",
    },
    1: {
      name: "SiteMap",
    },
    2: {
      name: "Profile",
    },
    3: {
      name: "Imagine",
    },
  },
  0: {
    fullname: "Lab 0: How to Build an Accessible Learning Lab",
    name: "Lab0",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  1: {
    fullname: "Lab 1: Accessibility to Sound and Speech",
    name: "Lab1",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  2: {
    fullname: "Lab 2: Accessibility to Color Blindness",
    name: "Lab2",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  3: {
    fullname: "Lab 3: Accessibility with Screen Readers",
    name: "Lab3",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  4: {
    fullname: "Lab 4: Accessibility to Dexterity",
    name: "Lab4",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  5: {
    fullname: "Lab 5: Accessibility with Cognitive Impairments",
    name: "Lab5",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  6: {
    fullname: "Lab 6: Ethics of AI",
    name: "Lab6",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  7: {
    fullname: "Lab 7: AI Cybersecurity",
    name: "Lab7",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  8: {
    fullname: "Lab 8: Algorithmic Bias",
    name: "Lab8",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  9: {
    fullname: "Lab 9: Accessibility to Localization",
    name: "Lab9",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  10: {
    fullname: "Lab 10: Neural Networks In Machine Learning",
    name: "Lab10",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  11: {
    fullname: "Lab 11: Accessibility to Literacy",
    name: "Lab11",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  12: {
    fullname: "Lab 12: Accessibility to Identity",
    name: "Lab12",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  13: {
    fullname: "Lab 13: Human Cognitive Bias & AI Lab",
    name: "Lab13",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  14: {
    fullname: "Lab 14: Quantum Cryptography",
    name: "Lab14",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  15: {
    fullname: "Lab 15: AI Hallucinations",
    name: "Lab15",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
  16: {
    fullname: "Lab 16: Deepfake",
    name: "Lab16",
    0: {
      name: "About",
    },
    1: {
      name: "Reading",
    },
    2: {
      name: "Exercise",
    },
    3: {
      name: "Reinforcement",
    },
    4: {
      name: "Quiz",
    },
  },
};
// for shared component
export const EXERCISE_IDLE = "EXERCISE_IDLE";
export const EXERCISE_PLAYING = "EXERCISE_PLAYING";
